import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, use } from "react";

type SearchResultsTitleContextValue = {
    query: string;
};

type SearchResultsTitleContextProviderProps = RequireChildrenFor<{
    query: string;
}>;

export const SearchResultsTitleContext = createContext<
    SearchResultsTitleContextValue | undefined
>(undefined);
SearchResultsTitleContext.displayName = "SearchResultsTitleContext";

export const SearchResultsTitleContextProvider = ({
    query,
    children
}: SearchResultsTitleContextProviderProps) => {
    return (
        <SearchResultsTitleContext
            value={{
                query
            }}
        >
            {children}
        </SearchResultsTitleContext>
    );
};

export const useSearchResultsTitleContext = () => {
    const context = use<SearchResultsTitleContextValue | undefined>(
        SearchResultsTitleContext
    );

    if (!isDefined(context)) {
        throw new Error(
            `${SearchResultsTitleContext.displayName} is undefined.`
        );
    }

    return context;
};
